/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `MAP` - MAP
 * * `ANALYTICS` - ANALYTICS
 * * `EMISSIONS` - EMISSIONS
 * @export
 */
export const InitialScreenAfterLoginEnum = {
    Map: 'MAP',
    Analytics: 'ANALYTICS',
    Emissions: 'EMISSIONS'
} as const;
export type InitialScreenAfterLoginEnum = typeof InitialScreenAfterLoginEnum[keyof typeof InitialScreenAfterLoginEnum];


export function instanceOfInitialScreenAfterLoginEnum(value: any): boolean {
    for (const key in InitialScreenAfterLoginEnum) {
        if (Object.prototype.hasOwnProperty.call(InitialScreenAfterLoginEnum, key)) {
            if (InitialScreenAfterLoginEnum[key as keyof typeof InitialScreenAfterLoginEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InitialScreenAfterLoginEnumFromJSON(json: any): InitialScreenAfterLoginEnum {
    return InitialScreenAfterLoginEnumFromJSONTyped(json, false);
}

export function InitialScreenAfterLoginEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitialScreenAfterLoginEnum {
    return json as InitialScreenAfterLoginEnum;
}

export function InitialScreenAfterLoginEnumToJSON(value?: InitialScreenAfterLoginEnum | null): any {
    return value as any;
}

export function InitialScreenAfterLoginEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): InitialScreenAfterLoginEnum {
    return value as InitialScreenAfterLoginEnum;
}

